import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

const EducationIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 23 20" {...props}>
      <path
        d="M22.1192 4.56909L11.8493 0.945614C11.7117 0.897035 11.5616 0.897035 11.424 0.945614L1.1541 4.56909C0.898761 4.65918 0.72788 4.90037 0.72754 5.17114C0.727199 5.44191 0.897525 5.68348 1.15265 5.77416L11.4225 9.42517C11.4918 9.4498 11.5642 9.46212 11.6366 9.46212C11.7091 9.46212 11.7815 9.4498 11.8507 9.42517L22.1206 5.77416C22.3757 5.68348 22.546 5.44191 22.5457 5.17114C22.5454 4.90037 22.3745 4.65918 22.1192 4.56909Z"
        fill={colors.primary}
      />
      <path
        d="M21.0108 13.101V7.52539L19.7324 7.97987V13.101C19.3474 13.3226 19.0879 13.7379 19.0879 14.2141C19.0879 14.6902 19.3474 15.1055 19.7324 15.3272V18.4685C19.7324 18.8215 20.0186 19.1077 20.3716 19.1077C20.7246 19.1077 21.0108 18.8215 21.0108 18.4685V15.3272C21.3959 15.1056 21.6554 14.6903 21.6554 14.2141C21.6554 13.7379 21.3959 13.3226 21.0108 13.101Z"
        fill={colors.primary}
      />
      <path
        d="M11.6364 10.7404C11.417 10.7404 11.2009 10.7031 10.9941 10.6296L5.2207 8.57715V11.39C5.2207 12.0782 5.93861 12.6601 7.3545 13.1197C8.58863 13.5202 10.1093 13.7409 11.6364 13.7409C13.1635 13.7409 14.6842 13.5202 15.9184 13.1197C17.3343 12.6601 18.0522 12.0782 18.0522 11.39V8.57715L12.2788 10.6296C12.072 10.7031 11.8559 10.7404 11.6364 10.7404Z"
        fill={colors.primary}
      />
    </SvgIcon>
  );
};

export default EducationIcon;
